import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { ThemeProvider } from './app/theme';
import { I18nProvider } from './app/i18n';
import './styles/index.css';

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ThemeProvider>
      <I18nProvider>
        <App />
      </I18nProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// Crawler-only fallback blocks are redundant (duplicate h1) once React renders
document.getElementById('prerender-content')?.remove();
document.querySelectorAll('.seo-fallback').forEach((n) => n.remove());

const loadExtFonts = () => {
  void import('./styles/fonts-ext.css');
};
if (typeof window.requestIdleCallback === 'function') {
  window.requestIdleCallback(loadExtFonts, { timeout: 2500 });
} else {
  window.setTimeout(loadExtFonts, 800);
}
